import { applyIdentityMask, applyMask } from '@src/common/masks';

export const maskCardNumber = (value: string) => applyMask(value, 'card_number');
export const maskSecurityCode = (value: string) => applyMask(value, 'security_card_code');
export const maskCardValidity = (value: string) => applyMask(value, 'payment_card_validity');
export const maskHolderIdentity = (value: string) => applyIdentityMask(value);
export const maskBrazilianZipCode = (value: string) => applyMask(value, 'br_postal_code');

export const ZIP_CODE_MASKS = {
  br_postal_code: maskBrazilianZipCode,
} as const;
